import ReactApexChart from "react-apexcharts";
import Skeleton from "react-loading-skeleton";

const PathologyTestBreakdownChart = ({ tests, isLoading }) => {
  if (isLoading) {
    return <Skeleton height={400} />;
  }
  
  const categoryCounts = tests.reduce((acc, test) => {
    const category = test.categoryName || "Uncategorized";
    acc[category] = (acc[category] || 0) + 1;
    return acc;
  }, {});

  const labels = Object.keys(categoryCounts);
  const series = Object.values(categoryCounts);
  const totalTests = tests.length;
  const chartColors = ['#465DFF', '#6AC75A', '#67BAF1', '#F59E0B', '#EF4444', '#D946EF'];

  const chartState = {
    series: series,
    options: {
      chart: { type: 'donut' },
      labels: labels,
      colors: chartColors,
      legend: { show: false },
      dataLabels: { enabled: false },
      plotOptions: {
        pie: {
          donut: {
            size: "75%",
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '16px',
                fontWeight: 'bold',
                formatter: (val) => val.length > 15 ? val.slice(0, 14) + '...' : val,
              },
              total: {
                show: true,
                label: 'Total Tests',
                fontSize: '18px',
                fontWeight: 600,
                color: '#373d3f',
                formatter: () => totalTests.toLocaleString(),
              },
            },
          },
        },
      },
    },
  };

  const breakdownData = labels.map((label, index) => ({
    name: label,
    count: series[index],
    percentage: totalTests > 0 ? ((series[index] / totalTests) * 100).toFixed(2) : "0.00",
    color: chartColors[index % chartColors.length],
  }));

  return (
    <div>
      <div id="chart" className="dashboard-donut-chart -mt-4">
        <ReactApexChart options={chartState.options} series={chartState.series} type="donut" height={250} />
      </div>
      <div className="mt-4 space-y-3 px-2">
        {breakdownData.map((item, index) => (
          <div key={index} className="flex items-center justify-between text-sm">
            <div className="flex items-center gap-3">
              <span className="h-3 w-3 rounded-full" style={{ backgroundColor: item.color }}></span>
              <span>{item.name}: {item.count.toLocaleString()}</span>
            </div>
            <span className="font-medium text-gray-600">{item.percentage}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PathologyTestBreakdownChart;